import axios from 'axios'

export function getHomePageData({ commit, store }, timezone) {
    return new Promise((resolve, reject) => {
        axios
            .get("/user/mobilehomepage")
            .then(response => {
                commit('setHomePageData', response.data.data)
                resolve(true)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function resetStore({ commit, store }) {
    commit('resetStore')
}
